const variable = {
  width: '1260px',
};

export const breakPoint = {
  mobile: 768,
  tablet: 1260,
  desktop: 1440,
};

const color = {
  mainTheme: '#ED1B23',
  grayColor: '#999',
};

const nft = {
  coverBg: '#f1f2f7',
};

const mixin = {
  convertMobileWidth: (property, pixel) => {
    if (Number.isNaN(Number(pixel))) {
      const valueArray = pixel.split(' ');
      return `${property}: ${valueArray
        .map((value) =>
          Number.isNaN(Number(value))
            ? value
            : `${100 * (value / breakPoint.mobile)}vw`,
        )
        .join(' ')}`;
    }
    return `${property}: ${100 * (pixel / breakPoint.mobile)}vw`;
  },
  convertDesktopWidth: (property, pixel) =>
    `${property}: ${100 * (pixel / breakPoint.desktop)}vw`,
};

export const theme = {
  color: color,
  variable: variable,
  pages: {
    nft: nft,
  },
  mixin: mixin,
  breakPoint: breakPoint,
};

export default theme;
